import { dataMinusCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMinusCircle = /*#__PURE__*/createIcon(dataMinusCircle)
export default IconMinusCircle
